// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"iV-z","inlineTitle":"jV-z","sponsoredAdsWrapper":"kV-z","marketplaceRecosWrapper":"lV-z"};